module.exports = __webpack_public_path__ + "img/p8-p1-diaoxiang.e99b8a8a.png";